
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("cknb6", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $8f9954ff7d9150a2$export$2cd8252107eb640b; });
// ====================================================================================
// headerSearch.module
// ====================================================================================

var $jG4hL = parcelRequire("jG4hL");
const $8f9954ff7d9150a2$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    let resInterval = null;
    const $header = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("header");
    const $bottomNav = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".header__bottom-nav");
    const bottomNavDetails = {
        top: 0
    };
    if ($bottomNav.length > 0) bottomNavDetails.top = $bottomNav.offset().top;
    const closeSearch = (num)=>{
        // alert(`closeSearch ${num}`);
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".form.form-header-search").slideUp(function() {
            $header.css("height", "");
        }).removeClass("active");
        if ($bottomNav.length > 0) $bottomNav.css("top", "");
    };
    // if document.ready needed
    const whenComplete = ()=>{
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            $header.find('[data-js="open-search"]').on("click", function(e) {
                let $searchForm = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".form.form-header-search");
                if ($searchForm.hasClass("active")) closeSearch("1");
                else {
                    if ($bottomNav.length > 0) $bottomNav.hide();
                    $searchForm.slideDown(100, function() {
                        if ($bottomNav.length > 0) {
                            let headerHeight = $header.outerHeight();
                            $bottomNav.css("top", `${headerHeight}px`);
                            $bottomNav.show();
                        }
                    }).addClass("active");
                    $header.css("height", "auto");
                }
            });
            $header.find(".form.form-header-search .btn--close").on("click", ()=>closeSearch("2"));
            window.addEventListener("resize", function(e) {
                // if (window.innerWidth < 991) closeSearch("3");
                if ($bottomNav.length > 0) {
                    if (resInterval) clearInterval(resInterval);
                    resInterval = setInterval(function() {
                        bottomNavDetails.top = $bottomNav.offset().top;
                    }, 400);
                }
            });
        } else setTimeout(()=>whenComplete(), 400);
    };
    whenComplete();
};

});


//# sourceMappingURL=headerSearch.module.1f374f46.js.map
